import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { LoginPage } from "./pages/auth/LogInPage";
import { HomePage } from "./pages/homePage/HomePage";
import { checkAuthLoader } from "./pages/RootLayout";
import { CategoryPage } from "./pages/category/CategoryPage";
import { ErrorPage } from "./pages/error/ErrorPage";
import { RootLayout } from "./pages/RootLayout";
import { OrderPage } from "./pages/order/OrderPage";
import { OrderDetailPage } from "./pages/order/orderDetail/OrderDetailPage";
import { OrderOutlet } from "./pages/order/OrderOutlet";
import "./App.css";
import { CancellationPage } from "./pages/cancellation/CancellationPage";
import { RefundPage } from "./pages/refund/RefundPage";
import { RefundOutlet } from "./pages/refund/RefundOutlet";
import { RefundDetailPage } from "./pages/refund/refundDetail/RefundDetailPage";
import { CancellationOutlet } from "./pages/cancellation/CancellationOutlet";
import { CancellationDetailPage } from "./pages/cancellation/cancellationDetail/CancellationDetailPage";
import { ProductListPage } from "./pages/category/productList/ProductListPage";
import { ProductDetailPage } from "./pages/category/productDetail/ProductDetailPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    loader: checkAuthLoader,
    children: [
      { index: true, element: <HomePage /> },
      {
        path: ":category",
        children: [
          { index: true, element: <CategoryPage /> },
          { path: ":inventory_id", element: <ProductListPage /> },
          { path: ":inventory_id/:productId", element: <ProductDetailPage /> },
        ],
      },
      {
        path: "orders",
        element: <OrderOutlet />,
        children: [
          { index: true, element: <OrderPage /> },
          { path: ":orderId", element: <OrderDetailPage /> },
        ],
      },
      {
        path: "cancelled_orders",
        element: <CancellationOutlet />,
        children: [
          { index: true, element: <CancellationPage /> },
          { path: ":cancellationId", element: <CancellationDetailPage /> },
        ],
      },
      {
        path: "refund_orders",
        element: <RefundOutlet />,
        children: [
          { index: true, element: <RefundPage /> },
          { path: ":refundId", element: <RefundDetailPage /> },
        ],
      },
    ],
  },
  { path: "login", element: <LoginPage /> },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
